import { useEffect, useState } from "react";
import { useSession } from "../auth/useSession";
import { scopedBrowserStorageKey } from "./scopedBrowserStorage";
import { isPurchasingTarget, type PurchasingTarget } from "./purchasingTarget";

export function usePurchasingTarget(scope: string) {
  const { user } = useSession();
  const key = scopedBrowserStorageKey(`truucost.purchasing-target.v1:${scope}`, user);
  const [stored, setStored] = useState<{ key: string | null; value: PurchasingTarget | null }>(() => ({ key, value: read(key) }));
  const value = stored.key === key ? stored.value : read(key);
  useEffect(() => {
    if (stored.key !== key) setStored({ key, value: read(key) });
  }, [key, stored.key]);
  function update(next: PurchasingTarget) {
    setStored({ key, value: next });
    if (key) { try { localStorage.setItem(key, JSON.stringify(next)); } catch { /* Session-only if storage is unavailable. */ } }
  }
  return { value, update };
}
function read(key: string | null): PurchasingTarget | null {
  try { const value: unknown = key ? JSON.parse(localStorage.getItem(key) ?? "null") : null; return isPurchasingTarget(value) ? value : null; } catch { return null; }
}
